module.exports = __webpack_public_path__ + "static/media/1.1deef1a0.jpg";